// extracted by mini-css-extract-plugin
export default {"departments":"jH-z","departmentHeading":"kH-z","departmentSection":"lH-z","departmentName":"mH-z","departmentLink":"nH-z","expandIcon":"oH-z"};